import { render, staticRenderFns } from "./index.vue?vue&type=template&id=55a3e05c&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=55a3e05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a3e05c",
  null
  
)

export default component.exports